module.exports = __webpack_public_path__ + "img/order7.30802e1f.png";